module.exports = __webpack_public_path__ + "img/portraits_05_V.89ef28a2.webp";